import usePDPContext from './usePDPContext';

const usePdpId = () => usePDPContext()?.id ?? null;

export default usePdpId;
